export const YOKIHUB_PAYMENT_PENDING_KEY = 'yokihub_payment_pending';
export const YOKIHUB_PAYMENT_RETURN_KEY = 'yokihub_payment_return';
export const YOKIHUB_PAYMENT_RETURN_MESSAGE = 'YOKIHUB_PAYMENT_RETURN';
export const YOKIHUB_PAYMENT_RETURN_CHANNEL = 'yokihub_payment_return_channel';

export type YokihubPaymentReturnMessage = {
  type: typeof YOKIHUB_PAYMENT_RETURN_MESSAGE;
  orderId?: string;
};

export type YokihubPaymentReturnPayload = {
  orderId?: string;
  at: number;
};

export const isYokihubPaymentReturnMessage = (
  data: unknown,
): data is YokihubPaymentReturnMessage =>
  Boolean(
    data &&
      typeof data === 'object' &&
      'type' in data &&
      (data as YokihubPaymentReturnMessage).type ===
        YOKIHUB_PAYMENT_RETURN_MESSAGE,
  );

export const markPaymentPending = () => {
  localStorage.setItem(YOKIHUB_PAYMENT_PENDING_KEY, String(Date.now()));
};

export const clearPaymentPending = () => {
  localStorage.removeItem(YOKIHUB_PAYMENT_PENDING_KEY);
};

export const signalPaymentReturn = (orderId?: string) => {
  const payload: YokihubPaymentReturnPayload = {
    orderId,
    at: Date.now(),
  };
  localStorage.setItem(YOKIHUB_PAYMENT_RETURN_KEY, JSON.stringify(payload));
  clearPaymentPending();

  if (typeof BroadcastChannel !== 'undefined') {
    const channel = new BroadcastChannel(YOKIHUB_PAYMENT_RETURN_CHANNEL);
    channel.postMessage(payload);
    channel.close();
  }
};

export const parsePaymentReturnPayload = (
  value: string | null,
): YokihubPaymentReturnPayload | null => {
  if (!value) return null;
  try {
    return JSON.parse(value) as YokihubPaymentReturnPayload;
  } catch {
    return null;
  }
};

export const getPaymentReturnOrderId = () =>
  new URLSearchParams(window.location.search).get('orderId') || undefined;

export const notifyPaymentReturnOpener = (orderId?: string) => {
  if (!window.opener) return false;

  try {
    window.opener.postMessage(
      {
        type: YOKIHUB_PAYMENT_RETURN_MESSAGE,
        orderId,
      } satisfies YokihubPaymentReturnMessage,
      '*',
    );
    return true;
  } catch {
    return false;
  }
};

export const closePaymentReturnWindow = () => {
  window.setTimeout(() => {
    window.close();
    if (window.opener && !window.opener.closed) {
      window.opener.focus();
    }
  }, 100);
};

export const handlePaymentReturnPageLoad = () => {
  const orderId = getPaymentReturnOrderId();
  if (!orderId) {
    return false;
  }

  signalPaymentReturn(orderId);
  notifyPaymentReturnOpener(orderId);
  closePaymentReturnWindow();
  return true;
};
